(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["focus-product-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.focus-offer';

    const updateVariantState = (section) => {
      const variantSelect = section.querySelector('[data-focus-offer-variant-select]');
      if (!variantSelect) {
        return;
      }

      const option = variantSelect.selectedOptions[0];
      if (!option) {
        return;
      }

      const price = section.querySelector('[data-focus-offer-price]');
      const compare = section.querySelector('[data-focus-offer-compare]');
      const save = section.querySelector('[data-focus-offer-save]');
      const buttonPrice = section.querySelector('[data-focus-offer-button-price]');
      const stock = section.querySelector('[data-focus-offer-stock]');
      const submit = section.querySelector('[data-focus-offer-submit]');

      if (price) {
        price.textContent = option.dataset.price || '';
      }

      if (buttonPrice) {
        buttonPrice.textContent = option.dataset.price || '';
      }

      const rawPrice = Number(option.dataset.rawPrice || 0);
      const rawCompareAt = Number(option.dataset.rawCompareAt || 0);
      const hasSavings = rawCompareAt > rawPrice;

      if (compare) {
        compare.textContent = hasSavings ? option.dataset.compareAt || '' : '';
        compare.hidden = !hasSavings;
      }

      if (save) {
        if (hasSavings) {
          const savingsPercent = Math.round(((rawCompareAt - rawPrice) * 100) / rawCompareAt);
          save.textContent = `-${savingsPercent}%`;
          save.hidden = false;
        } else {
          save.textContent = '';
          save.hidden = true;
        }
      }

      const available = option.dataset.available === 'true';

      if (submit) {
        submit.disabled = !available;
      }

      if (stock) {
        stock.textContent = available ? stock.dataset.stockAvailable || '' : stock.dataset.stockUnavailable || '';
        stock.classList.toggle('is-unavailable', !available);
      }
    };

    const bindQuantity = (section) => {
      if (section.dataset.focusOfferBound === 'true') {
        return;
      }

      section.dataset.focusOfferBound = 'true';

      const input = section.querySelector('[data-focus-offer-qty-input]');
      const buttons = section.querySelectorAll('[data-focus-offer-qty-change]');
      const variantSelect = section.querySelector('[data-focus-offer-variant-select]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!input) {
            return;
          }

          const delta = Number(button.dataset.focusOfferQtyChange || 0);
          const nextValue = Math.max(1, Number(input.value || 1) + delta);
          input.value = `${nextValue}`;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      if (input) {
        input.addEventListener('change', () => {
          if (Number(input.value || 0) < 1) {
            input.value = '1';
          }
        });
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          updateVariantState(section);
        });
      }

      updateVariantState(section);
    };

    const bindSections = (scope) => {
      const root = scope instanceof Element ? scope : document;
      root.querySelectorAll(selector).forEach((section) => bindQuantity(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindSections(document), { once: true });
    } else {
      bindSections(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
